'use client';

import { useEffect } from 'react';
import { getUserData } from '@/helpers/local-storage';
import { sendUserInfoToLytics } from '@/lib/p13n';

interface LyticsTrackerProps {
  /** Page name or identifier for tracking */
  pageName?: string;
}

/** Tracks page views in Lytics for the current user; add to any page. */
export function LyticsTracker({ pageName }: LyticsTrackerProps) {
  useEffect(() => {
    const userData = getUserData();
    if (!userData) return;

    const { uid, role, firstName, lastName, email } = userData;

    if (uid && role && email) {
      // Delay to ensure the Lytics script has loaded
      const timeoutId = setTimeout(() => {
        sendUserInfoToLytics(uid, role, firstName, lastName, email);

        if (process.env.NODE_ENV === 'development' && pageName) {
          console.log(`Lytics tracking: ${pageName}`);
        }
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [pageName]);

  return null;
}
